// BYO pack grouping: one remove control clears every line in the pack.
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.byo-pack__remove');
  if (!btn) return;
  e.preventDefault(); e.stopPropagation();
  const pack = btn.closest('.byo-pack');
  const updates = {};
  (pack.dataset.byoKeys || '').split(',').filter(Boolean).forEach((k) => { updates[k] = 0; });
  btn.disabled = true; pack.classList.add('is-deleting');
  try {
    await fetch((window.routes?.cart_update_url || '/cart/update') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates }) });
  } finally {
    if (window.location.pathname.replace(/\/$/, '').endsWith('/cart')) window.location.reload();
    else if (window.updateMiniCart) window.updateMiniCart(true); else window.location.reload();
  }
}, true);
